<template>
  <div class="template-lib-layer">
    <templateMaterialLibDialog
      :visible="ShowTemplateMaterialLibDialog"
    ></templateMaterialLibDialog>
    <libUseTemplateLoadingMask
      v-show="ShowLibUseTemplateLoading"
    ></libUseTemplateLoadingMask>
    <!--ShowLibUseTemplateLoading-->
    <firstTemplateLoadingMask
      v-show="ShowFirstTemplateLoading"
    ></firstTemplateLoadingMask>
    <sideBarTemplateDialog
      v-show="ShowSideBarTemplateDialog"
    ></sideBarTemplateDialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import templateMaterialLibDialog from "./emodal/templateLib/templateMaterialLibDialog.vue";
import libUseTemplateLoadingMask from "./emodal/templateLib/libUseTemplateLoadingMask.vue";
import firstTemplateLoadingMask from "./emodal/templateLib/firstTemplateLoadingMask.vue";
import sideBarTemplateDialog from "./emodal/templateLib/sideBarTemplateDialog";

export default {
  name: "templateMaterialLibrary",
  data() {
    return {};
  },
  components: {
    templateMaterialLibDialog,
    libUseTemplateLoadingMask,
    firstTemplateLoadingMask,
    sideBarTemplateDialog,
  },
  computed: {
    ...mapGetters({
      ShowTemplateMaterialLibDialog: "ShowTemplateMaterialLibDialog",
      ShowLibUseTemplateLoading: "ShowLibUseTemplateLoading",
      ShowFirstTemplateLoading: "ShowFirstTemplateLoading",
      ShowSideBarTemplateDialog: "ShowSideBarTemplateDialog",
    }),
  },
  mounted() {
    console.log("sideBarTemplateDialog", sideBarTemplateDialog);
  },
};
</script>

<style>
.template-lib-layer {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  height: 0px;
  z-index: 25;
}
</style>



// WEBPACK FOOTER //
// src/components/TemplateMaterialLibrary.vue